import { StaticImage } from 'gatsby-plugin-image';

import Anchor from '~components/Anchor/Anchor';

const SinglePostNtmCta = () => {
    return (
        <div
            className="bg-blue-pink rounded-md shadow blue-pink-gradient flex items-center mb-8 print:hidden"
            data-qa="single-article-ntm"
        >
            <div className="min-w-[100px] md:w-[111px]">
                <StaticImage
                    src="../../images/people/ntm-cta-woman.jpg"
                    height={115}
                    width={111}
                    alt="woman"
                />
            </div>
            <div className="p-3 md:p-4">
                <div className="md:font-semibold text-black text-base mb-1 md:mb-2">
                    NEW TO MEDICARE?
                </div>
                <Anchor
                    className="font-semibold text-base text-link"
                    to="/new-to-medicare"
                    data-wa-link="NTM: Get Answers"
                    data-qa="learn-to-know-ntm"
                >
                    Learn what you need to know in 15 min or less.
                </Anchor>
            </div>
        </div>
    );
};

export default SinglePostNtmCta;
